module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('h2', [_vm._v("Fanwalk Brick Options")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('catalog')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n                        Bricks are available in two options: an 8” x 8” size with a D.C. United logo, or a 4” x 8” size without a logo. Each brick is customizable with names or messages. All inscriptions are subject to review by D.C. United. You will also have an opportunity to order a display case for your complimentary replica brick, as well as additional replicas. Please call to place an order outside of the contiguous United States (International, Alaska or Hawaii).\n                    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13a9d01e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop.vue
// module id = K8GP
// module chunks = 1